import React, { Component } from 'react';
import Modal from './_Modal';
var { FaGooglePlus } = require('react-icons/lib/fa');
import styled from 'styled-components';

// const RoleAndIndustry = styled.div`
//   margin-top: 10px;
//   width: 500px;
//   height: 50px;
//   ${'' /* height: 100px; */}
//   div {
//     width: 210px;
//     float: left;
//     margin: 0 20px;
//     div {
//       width: auto;
//       margin: 0;
//     }
//   }
// `

const Hr = styled.hr`
  margin: 0;
  float: none;
  border: 0.5px solid lightgrey;
`

const Icon = styled.span`
  font-size: 1.3em;
  margin-right: 7px;
`

// const Terms = styled.div`
//   ${'' /* margin: 50px 0; */}
//   width: 500px;
//   ${'' /* padding: 20px; */}
//   ${'' /* background-color: lightblue; */}
// `

const Buttons = styled.div`
  float: none;
  text-align: center;
  margin-top: 15px;
  button {
    ${'' /* background-color: #69f; */}
    border: none;
    border-radius: 5px;
    margin: 30px;
    color: white;
    &:hover {
      ${'' /* background-color: #36e; */}
    }
  }
`
// const CancelButton = styled.button`
//   background-color: #69f;
//   &:hover {
//     background-color: #36e;
//   }
// `

const SignUpButton = styled.button`
  background-color: #fa3;
  &:hover {
    background-color: #e82;
  }
`

const SubmitButton = styled.button`
  background-color: ${props => props.disabledProp ? 'lightgrey' : '#69f'}};
  &:hover {
    background-color: ${props => props.disabledProp ? 'grey' : '#36e'}};
    cursor: pointer;
  }
`

const Wrapper = styled.div`
  width: 500px;
  text-align: center;
`

const LeftAndRight = styled.div`
  text-align: center;
  width: 500px;
  height: 140px;
  ${'' /* background-color: pink; */}
`
const AlignLeft = styled.div`
  ${'' /* background-color: lightgreen; */}
  border: ${props => props.border ? '3px solid #cfc' : '3px solid white'};
  display: inline;
  float: left;
  width: 50%;
  padding: 20px;
  height: 140px;
  text-align: left;
  Input, TextArea {
    margin-bottom: 10px;
  }
`

const AlignRight = styled.div`
  border: ${props => props.border ? '3px solid #cfc' : '3px solid white'};
  display: inline;
  float: left;
  width: 50%;
  height: 140px;
  text-align: center;
  padding: 20px;
`

const GoogleBox = styled.div`
  font-size: 1.1em;
  color: white;
  display: inline;
  background-color: red;

  ${'' /* width: 200px;
  height: 50px; */}
  div {
    padding: 10px;
    background-color: #eb5447;
    &:hover {
      background-color: #db4437;
      cursor: pointer;
    }
  }
  FaGooglePlus {
    padding-right: 20px;
  }
`

const Input = styled.input`
  width: 100%;
`

const H3 = styled.h3`
  margin-top: 0px;
`

// const FaGooglePlus = styled(FaGooglePlus) {
//   background-color:red;
// }

class SignUpModal extends Component {
  constructor() {
    super()
    this.state = {
      email: '',
      password: '',
      google: false,
      emailpassword: false,
      role: '',
      industry: '',
      terms: false,
      validated: false
    }
  }
  // componentDidUpdate() {
  //   if (this.state.validated) console.log('VALIDATED:', this.state.validated);
  // }
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.open) {
  //     setTimeout(() => {
  //       nextProps.closeModal(nextProps.method)
  //     }, 1000);
  //   }
  // }
  onSignin = () => {
    this.props.signIn()
  }
  emailChange = e => {
    const emailpassword = (e.target.value && this.state.password) ? true : false;
    const google = emailpassword ? false : this.state.google;
    //   (e.target.value.includes("@") && e.target.value.includes(".") && this.state.password.length > 5) ?
    //   true : false;
    // const google =
    //   (e.target.value.includes("@") && e.target.value.includes(".") && this.state.password.length > 5) ?
    //   false : this.state.google;
      // const validated = (e.target.value || google) && this.state.terms ? true : false;
    this.setState({ email: e.target.value, emailpassword, google })
  }
  passwordChange = e => {
    const emailpassword = (this.state.email && e.target.value) ? true : false;
    const google = emailpassword ? false : this.state.google;
    // const emailpassword =
    //   (this.state.email.includes("@") && this.state.email.includes(".") && e.target.value.length > 5) ?
    //   true : false;
    // const google =
    //   (this.state.email.includes("@") && this.state.email.includes(".") && e.target.value.length > 5) ?
    //   false : this.state.google;
    // const validated = (emailpassword || google) && this.state.terms ? true : false;
    this.setState({ password: e.target.value, emailpassword, google })
  }
  setGoogle = () => {
    const google = this.state.google ? false : true;
    const emailpassword = google ? false : this.state.emailpassword;
    // const emailpassword =
    //   (this.state.google && this.state.email.includes("@") && this.state.email.includes(".") && this.state.password.length > 5) ?
    //   true : false;
    // const validated = (emailpassword || google) && this.state.terms ? true : false;
    this.setState({ emailpassword, google })
  }
  // setTerms = () => {
  //   const terms = this.state.terms ? false : true;
  //   const validated = (this.state.emailpassword || this.state.google) && terms ? true : false;
  //   this.setState({ terms, validated })
  //   // () => this.setState({ terms: !this.state.terms })
  // }
  tryLogin = () => {
    // console.log('HERE?');
    const { emailpassword, google, email, password } = this.state;
    if (emailpassword || google) {
      if (emailpassword) { this.props.signInUser(email, password) }
      if (google) {
        this.props.closeModal(this.props.method)
        this.props.signInWithGoogle()
      }
    }
    // if (this.state.validated && this.state.emailpassword) { this.props.signUpUser() }
    // if (this.state.validated)
    else (alert("Please a valid email and password OR Google Sign Up"))
  }
  render() {
    const validated = this.state.emailpassword || this.state.google;
    return (
      <Modal
        open={this.props.open}
        close={() => this.props.closeModal(this.props.method)}
      >
        <Wrapper>
          <H3>Envelope Login</H3>
          <Hr />
          <LeftAndRight>
            <AlignLeft border={this.state.emailpassword}>
              <div>Email:</div>
              <Input
                autoFocus
                onChange={this.emailChange}
                value={this.state.email}
              />
              <div>Password:</div>
              <Input
                type="password"
                onChange={this.passwordChange}
                value={this.state.password}>
              </Input>
            </AlignLeft>
            <AlignRight border={this.state.google}>
              <p>OR:</p>
              <GoogleBox onClick={this.setGoogle}>
                <div><Icon><FaGooglePlus /></Icon> Log in with Google </div>
              </GoogleBox>
            </AlignRight>
          </LeftAndRight>
          <Hr />
          <Buttons>
            {/* <CancelButton onClick={() => this.props.closeModal(this.props.method)}>
              Cancel
            </CancelButton> */}
            <SignUpButton onClick={this.props.switchToSignup}>
              Switch to Sign Up
            </SignUpButton>
            <SubmitButton
              disabledProp={!validated}
              // style={{backgroundColor: this.state.validated ? '#69f' : 'grey'}}
              onClick={this.tryLogin}>Log In</SubmitButton>
          </Buttons>
        </Wrapper>

      </Modal>
    )
  }
}

export default SignUpModal;



// WEBPACK FOOTER //
// ./src/_LoginModal.js